import { CircularProgress } from "@mui/material";

const OverlayLoader = () => {
  return (
    <div className="w-full h-screen flex justify-center items-center absolute top-0 left-0 z-[9999] overlayLoader">
      <CircularProgress color="inherit" />
    </div>
  );
};

export default OverlayLoader;
